import validator from './validator.js'

export default {
  request: {
    error: 'ohhhh, something went wrong:',
    permissionError: {
      title: 'Tip',
    },
    codeMessage: {
      message1: 'Not logged in or the token is invalid',
      message2: 'Sorry, insufficient permissions',
      message3: 'Unknown error, please try again later',
    },
    loginBox: {
      title: 'Confirm logout',
      confirmButtonText: 'Login again',
    },
    networkError: 'The network is abnormal, please try again later! ',
  },
  publish: {
    text: 'Apply',
    fail: 'Apply failed',
    success: 'Apply success',
  },
  push: {
    text: 'Apply',
    fail: 'Push Failed',
    success: 'Push Successfully',
  },
  download: {
    text: 'Download',
    fail: 'Download failed',
    success: 'Download success',
  },
  submitButtonText: 'Submit',
  confirmButtonText: 'Confirm',
  cancelButtonText: 'Cancel',
  deleteTips: 'Are you sure you want to delete?',
  form: {
    search: 'Search',
  },
  creativeType: {
    image: 'Images',
    video: 'Video',
    endcard: 'Interactive Endcard',
    interactiveVideo: 'Interactive Video',
    panorama: 'Panorama Endcard',
  },

  validator,
}
